<template>
  <span :class="fieldClass">
    <span :class="suffixClass" v-if="!waiting" @click.stop="getCode">发送验证码</span>
    <span :class="suffixClass" v-else>重新获取({{formatTime}})</span>
    <el-dialog
      :visible.sync="visible"
      title="请输入验证码"
      append-to-body
      width="400px"
      @open="onOpen"
      custom-class="verify-code-dialog">
      <h2 class="vcode-modal-title" slot="header">请输入验证码</h2>
      <el-form size="medium" >
        <el-form-item style="margin-bottom: 4px;vertical-align: middle;" :error="error">
          <el-input @input="handleError" style="width: 230px;" v-model="vcode" placeholder="请输入验证码" /><div style="display:inline-block;vertical-align: middle;"  v-loading="vcodeLoading" element-loading-spinner="el-icon-loading" ><img ref="vcode" class="v-code-img" style="width:120px;height:36px;display:inline-block;vertical-align:middle;cursor:pointer;" title="更换验证码" :src="src" @click.stop="onChangeVCode" alt="验证码" aria-label="验证码"></div>
        </el-form-item>
      </el-form>
      <el-button slot="footer" size="small" type="primary" :loading="loading" @click.stop="launch">发送短信</el-button>
    </el-dialog>
  </span>
</template>

<script>
import _ from 'lodash'
import {baseURL} from '@/config'
const COMPONENT_NAME = 'v-sms'
const NOT_EMPTY = '请输入短信验证码'
const ERROR = '请输入正确的验证码格式'
export default {
  name: COMPONENT_NAME,
  props: {
    id: String,
    el: {
      type: String,
      default: 'el-form-item'
    },
    fieldClass: String,
    placeholder: String,
    interval: {
      type: Number,
      default: 60
    },
    action: {
      type: String
    },
    phone: {
      required: true
    },
    verify: { // 是否需要验证码
      type: Boolean,
      default: true
    },
    api: { // required
      type: String,
      default: 'app/registerSmsCode'
    },
    beforeSend: {
      type: Function,
      default () {
        return new Promise(resolve => {
          resolve(true)
        })
      }
    },
    options: {
      type: Object,
      default () {
        return {}
      }
    },
    tips: String,
    params: {
      type: Object,
      default () {
        return {}
      }
    },
    suffixClass: {},
    value: {}
  },
  watch: {
    options: {
      immediate: true,
      deep: true,
      handler () {
        if (this.options) this.opts = _.merge({}, this.opts, this.options)
      }
    },
    value: {
      immediate: true,
      handler () {
        this.currentValue = this.value
      }
    }
  },
  data () {
    return {
      time: 0,
      waiting: false,
      timer: null,
      error: '',
      first: true,
      send: false,
      visible: false,
      loading: false,
      currentValue: '',
      opts: { // 设置别名
        phone: 'mobile',
        code: 'verificationCode'
      },
      vcode: '',
      src: '',
      vcodeLoading: false, // 验证码加载
      vcodeLoadingError: false
    }
  },
  computed: {
    formatTime () {
      return this.time
    }
  },
  methods: {
    loadVCode () {
      if (this.verify) {
        let src = `${this.$FRAMEWORK.captchaUrl}?timestamp=${new Date().getTime()}`  
        let img = new Image()
        this.vcodeLoading = true
        img.src = src
        img.onload = () => {
          this.vcodeLoading = false
          this.vcodeLoadingError = false
          this.src = src
        }
        img.onerror = () => {
          this.vcodeLoading = false
          this.vcodeLoadingError = true
        }
      }
    },
    onInput (e) {
      if (!e) return
      this.$emit('input', this.currentValue)
    },
    onBlur () {
      if (this.currentValue) {
        if (/\d{6}/.test(this.currentValue)) this.errorTips = ''
        else this.errorTips = ERROR
      } else {
        this.errorTips = NOT_EMPTY
      }
    },
    done () {
      if (this.waiting) return
      if (this.time !== this.interval) this.time = this.interval
      this.$emit('is-send', this.send)
      this.waiting = true
      this.first = false
      this.send = true
      this.timer = setInterval(() => {
        this.time--
        if (this.time < 0) {
          clearInterval(this.timer)
          this.timer = null
          this.waiting = false
          this.time = 0
        }
      }, 1000)
    },
    async getCode () {
      if (this.beforeSend && typeof this.beforeSend === 'function') {
        if (await !this.beforeSend()) return
      }
      if (this.verify && !this.visible) {
        this.visible = true
        this.$nextTick(() => {
          this.loadVCode()
        })
      } else this.launch(false)
    },
    handleError () {
      if (!this.vcode) {
        this.error = '请输入验证码'
      } else {
        this.error = ''
      }
    },
    launch (v = true) {
      if (v) {
        if (!this.phone) {
          this.$emit('phone-empty')
          this.error = '请输入手机号码' // 自定义
          return
        }
        if (!this.vcode) {
          this.error = '请输入验证码'
          return
        } else {
          this.error = ''
        }
      }
      // 校验验证码是否正确
      this.loading = true
      this.$api(this.api, {
        [this.opts.phone]: this.phone,
        [this.opts.code]: this.vcode,
        ...this.params // 追加数据
      }).then(() => {
        this.visible = false
        this.loading = false
        this.error = ''
        this.done()
      }).catch(err => {
        this.loading = false
        this.error = (err.data && err.data.msg) || err.msg
        this.onChangeVCode()
      })
    },
    onOpen () {
      this.vcode = ''
      this.error = ''
      this.onChangeVCode()
    },
    onChangeVCode () {
      this.loadVCode()
    }
  }
}
</script>

<style lang="less">
.verify-code-dialog {
  .el-dialog__header {
    padding-bottom: 8px;
  }
  .el-dialog__body {
    padding: 14px 20px;
  }
  .el-dialog__footer {
    padding: 0px 20px 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/framework/widgets/sms.vue